import { render, staticRenderFns } from "./verfactura.vue?vue&type=template&id=0d333824"
import script from "./verfactura.vue?vue&type=script&lang=js"
export * from "./verfactura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports